import {useState, useEffect, useCallback, useRef} from "react";
import {useParams} from 'react-router-dom';
import {onlineProcessesService, userService} from "../../services";
import {useLoader} from "@quadral/quadral-component-common/dist/components/loader/LoaderContext";
import QuadralTabPanel from '@quadral/quadral-component-common/dist/components/tabPanel';
import QuadralToast, {quadralToast} from '@quadral/quadral-component-common/dist/components/toast';
import QuadralBadge from "@quadral/quadral-component-common/dist/components/badge"
import QuadralContainer from "@quadral/quadral-component-common/dist/components/container"
import QuadralTextField from "@quadral/quadral-component-common/dist/components/textField";
import QuadralList from "@quadral/quadral-component-common/dist/components/list";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Switch from "@mui/material/Switch";
import Details from "./Details";
import IncomeAndExpenses from "./IncomeAndExpenses";
import SupportingDocuments from './supportingDocument/SupportingDocuments'; //add OldWork_ prefix
import PersonList from "./PersonList";
import Activities from "./Activities";

import {useKeycloak} from '@react-keycloak/web';
import ParticipationValidationModal from "./ParticipationValidationModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faBan, 
    faCheck, 
    faMagnifyingGlass, 
    faCirclePause, 
    faEnvelope, 
    faFileInvoice, 
    faFileLines, 
    faUser, 
    faXmark, 
    faExclamationTriangle, 
    faInfoCircle, 
    faUsers, 
    faEuroSign, 
    faRotateLeft, 
    faChartColumn, 
    faCalendarDays 
} from "@fortawesome/free-solid-svg-icons";
import FormControlLabel from "@mui/material/FormControlLabel";
import Assistance from "./Assistance";


const SurveyParticipation = () => {
    const timeoutRef = useRef(null);
    const {keycloak} = useKeycloak();
    const roles = keycloak.tokenParsed?.realm_access?.roles || [];

    const [searchValue, setSearchValue] = useState('');
    const [searchResults, setSearchResults] = useState([]);

    const [statuses, setStatuses] = useState();
    const [supportingDocuments, setSupportingDocuments] = useState([]);

    const {participationId} = useParams();
    const [participation, setParticipation] = useState(null);
    const [persons, setPersons] = useState([]);
    const [personIds, setPersonIds] = useState([]);
    const [signatoryPerson, setSignatoryPerson] = useState();
    const [references, setReferences] = useState([]);
    const {showLoader, hideLoader} = useLoader();
    const [tabValue, setTabValue] = useState('1');
    const [canUpdate, setCanUpdate] = useState(false);
    const [updatedData, setUpdatedData] = useState(0);
    const [docsPerPerson, setDocsPerPerson] = useState([])

    const [participationVerified, setParticipationVerified] = useState(false);
    const [isTerminationModalOpen, setIsTerminationModalOpen] = useState(false);

    const [activitiesOrAssistances, setActivitiesOrAssistances] = useState(true)
    const [activityRecords, setActivityRecords] = useState();
    const [activityOrder, setActivityOrder] = useState('DESC');
    const [assistanceRecords, setAssistanceRecords] = useState();
    const [assistanceOrder] = useState('DESC');
    const [assistanceType, setAssistanceType] = useState('');
    const [deviationId, setDeviationId] = useState(null);
    const [surveyDetails, setSurveyDetails] = useState(null);

    const [updateRecords, setUpdateRecords] = useState(0);

    const documentStatusOptions = [
        {
            label: "A fournir",
            value: "a_fournir",
        },{
            label: "Validé",
            value: "valide",
        },{
            label: "Refusé",
            value: "refuse",
        }
    ]

    const STATUS_COLOR_MAP = {
        "Contrôle en cours": 'control',
        "En attente des PJ": 'warning',
        "Compléments attendu": 'warning',
        "En attente de lancement": 'info',
        "En attente de connexion": 'info',
        "En attente de réponse": 'info',
        "Premier courrier reçu": 'info',
        "Compléments fournis": 'info',
        "Contrôlée": 'info',
        "Validée": 'success',
        "Annulée": 'secondary',
    };

    const STATUS_ICON_MAP = {
        "Contrôle en cours": faFileLines,
        "En attente des PJ": faCirclePause,
        "Compléments attendu": faFileLines,
        "En attente de lancement": faCirclePause,
        "En attente de connexion": faUser,
        "En attente de réponse": faFileLines,
        "Premier courrier reçu": faFileLines,
        "Compléments fournis": faFileLines,
        "Contrôlée": faCheck,
        "Validée": faCheck,
        "Annulée": faBan,
    };

    const DEVIATION_STATUS_MAP = {
        Escalade_interne: 'Escaladé interne',
		Escalade_externe: 'Escaladé mandant' ,
        Retours_a_analyser_interne: 'Retours à analyser - interne' ,
		Retours_a_analyser_externe: 'Retours à analyser - mandant' ,
        Traite: 'Traité' ,
    }

    const DEVIATION_STATUS_COLOR_MAP = {
        Escalade_interne: 'warning',
        Escalade_externe: 'warning',
        Retours_a_analyser_interne: 'info',
        Retours_a_analyser_externe: 'info',
        Traite: 'success',
    }

    const DEVIATION_STATUS_ICON_MAP = {
        Escalade_interne: faExclamationTriangle,
        Escalade_externe: faExclamationTriangle,
        Retours_a_analyser_interne: faInfoCircle,
        Retours_a_analyser_externe: faInfoCircle,
        Traite: faCheck,
    }

    const fastSearchColumns = [
        {
            id: "label",
            label: "Nom de la participation",
        },
    ];

    const refreshPersonsData = useCallback(
        async function refreshPersonsData() {
            showLoader();
            onlineProcessesService.getPersonRecords(participationId)
                .then(dataReceived => {
                    setPersons(dataReceived);
                    hideLoader();
                })
                .catch(err => {
                    console.error(err);
                    hideLoader();
                });
        }, [participationId, showLoader, hideLoader]
    )

    useEffect(() => {
        refreshPersonsData();
    }, [participationId, refreshPersonsData])

    useEffect(() => {
        userService.hasRole('survey-participation.write').then(hasRole => setCanUpdate(hasRole));
    }, []);

    useEffect(() => {
        const statusCount = {
            a_fournir: 0,
            valide: 0,
            refuse: 0
        }

        supportingDocuments?.forEach((doc) => {
            if(doc.status && statusCount.hasOwnProperty(doc.status)){
                statusCount[doc.status]++;
            }
        });

        setStatuses(statusCount);
    }, [supportingDocuments]);

    function updateRecord(){
        setUpdateRecords(updateRecords + 1)
    }

    useEffect(()=>{
        const ids = [...new Set(persons.map(p => p.id))]
        setPersonIds(ids)
    },[persons])

    useEffect(() => {
        showLoader();
        onlineProcessesService.getSurveyParticipationById(participationId)
            .then((response) => {
                setParticipation(response);
                hideLoader();
            })
            .catch(err => {
                console.error(err);
                hideLoader();
            });
    }, [participationId, showLoader, hideLoader]);

    useEffect(() => {
        setDeviationId(participation?.deviationId ?? null);
    }, [participation])

    useEffect(() => {
        onlineProcessesService.getSignatoryPersonRecords(participationId)
            .then(dataReceived => {
                setSignatoryPerson(dataReceived[0]);
            })
            .catch(err => {
                console.error(err);
            });
    }, [participationId])

    useEffect(() => {
        onlineProcessesService.getReferences().then(refs => {
            setReferences(refs || {});
        });
    }, [participationId]);

    useEffect(() => {
        if (participation?.surveyId) {
            onlineProcessesService.getSurveyDetails(participation.surveyId)
                .then(data => setSurveyDetails(data))
                .catch(err => console.error(err));
        }
    }, [participation?.surveyId]);

    useEffect(() => {
        const fetchDocuments = async () => {
            const results = Object.fromEntries(
                (
                    await Promise.all(
                        personIds.map(async personId => {
                            const data = await onlineProcessesService.getSupportingDocuments(
                                participation?.id,
                                personId
                            );

                            const counts = data.reduce((acc, item) => {
                                acc[item.statusLabel] = (acc[item.statusLabel] || 0) + 1;
                                return acc;
                            }, {});

                            return [personId, counts];
                        })
                    )
                )
            );
            setDocsPerPerson(results)
        };

        if (participation?.id && personIds?.length) {
            fetchDocuments();
        }
    }, [updatedData, participation?.id, personIds]);

    useEffect(() => {
        showLoader();
        if (!participationId) return;
        const body={
            participationId:participationId,
            subtype:assistanceType,
            orderByDate:activityOrder,
        }
        onlineProcessesService.getActivityRecords({participationId}, body)
            .then(dataReceived => {
                setActivityRecords(dataReceived);
                hideLoader();
            })
            .catch(err => {
                console.error(err);
                hideLoader();
            });
    }, [participationId, updateRecords, assistanceType, activityOrder, showLoader, hideLoader]);
    
    useEffect(() => {
        const body={
            participationId:participationId,
            orderByDate:assistanceOrder,
        }
        onlineProcessesService.getAssistanceRecords({participationId}, body)
            .then(dataReceived => setAssistanceRecords(dataReceived))
            .catch(err => {
                console.error(err);
            });
    }, [participationId, updateRecords, assistanceOrder])

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    function formatDate(date){
        if(!date) return "inconnue";
        const formatedDate = new Date(date);
        if(isNaN(formatedDate)) return "invalide";

        return formatedDate.toLocaleDateString("fr-FR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        });
    }          

    function updateData(){
        setUpdatedData(updatedData + 1)
    }

    function mapReferences(value, reference) {
        const list = references?.[reference] || [];
        return list?.find(item => item.code === value)?.label || value;
    };

    function mapReferenceToOptions(refKey) {
        return references?.[refKey]?.map(item => ({
            code: item.code,
            label: item.label
        })) || [];
    }

    function handleTabs(event, newValue) {
        if (newValue !== tabValue) setTabValue(newValue);
    };

    function getDocStatus(statusCode) {
        const reference = documentStatusOptions.find(option => option.value === statusCode);
        return reference ? reference.label : statusCode
    }

    function getDocStatusIcon(statusCode) {
        if (statusCode) {
            switch (statusCode) {
                case 'valide' :
                    return <FontAwesomeIcon icon={faCheck}/>
                case 'refuse' :
                    return <FontAwesomeIcon icon={faXmark}/>
                default :
                    return <FontAwesomeIcon icon={faFileInvoice}/>
            }
        }
    }

    function getDocStatusCount(statusCode) {
        return statuses?.[statusCode] ?? 0;
    }

    const handleSearch = (value) => {
        setSearchValue(value);
        
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        if (!value) {
            setSearchResults([]);
            return;
        }

        timeoutRef.current = setTimeout(() => {
            onlineProcessesService
                .searchSurveyParticipations({
                    surveyId: participation?.surveyId,
                    contractCode: value
                })
                .then((res) => {
                    setSearchResults(res.surveyParticipations || []);
                })
                .catch((err) => {
                    console.error(err);
                    setSearchResults([]);
                });
        }, 600);
    };

    function calculateDaysUntilClosing(endDate) {
        if (!endDate) return null;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const closingDate = new Date(endDate);
        closingDate.setHours(0, 0, 0, 0);
        const daysRemaining = Math.ceil((closingDate - today) / (1000 * 60 * 60 * 24));
        return daysRemaining > 0 ? daysRemaining : 0;
    }

    function getClosingBadgeColor(daysRemaining) {
        if (daysRemaining < 30) return 'error';
        if (daysRemaining < 60) return 'warning';
        return 'success';
    }

    return (
        <div className="page-content">
            <QuadralToast/>
            <ParticipationValidationModal
                open={isTerminationModalOpen}
                setOpen={setIsTerminationModalOpen}
                statuses={statuses}
                getDocStatusCount={getDocStatusCount}
                getDocStatusIcon={getDocStatusIcon}
                getDocStatus={getDocStatus}
                participation={participation}
                showLoader={showLoader}
                hideLoader={hideLoader}
                setParticipationVerified={setParticipationVerified}
                participationVerified={participationVerified}
                quadralToast={quadralToast}
            />
            <h1>{`${participation?.firstname} ${participation?.lastname} - ${participation?.name}`}</h1> 
            <QuadralContainer orientation='row' style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.5rem', alignItems: 'center'}}>
                {(participation?.communicationChannel) &&
                    <QuadralBadge
                        label={participation.communicationChannel}
                        color="secondary"
                        style={{color:'#000', textTransform: 'capitalize'}}
                        icon={
                            <FontAwesomeIcon icon={participation.communicationChannel === 'email' ? faEnvelope : faFileLines}/>
                        }
                    />
                }
                { (participation?.statusLabel) &&
                    <QuadralBadge
                        label={participation.statusLabel}
                        color={STATUS_COLOR_MAP[participation.statusLabel] ?? 'info'}
                        icon={<FontAwesomeIcon icon={STATUS_ICON_MAP[participation.statusLabel] ?? faFileLines}/>}
                    /> 
                }
                { (participation?.deviationStatus) &&
                    <QuadralBadge
                        label={DEVIATION_STATUS_MAP[participation.deviationStatus] ?? participation.deviationStatus}
                        color={DEVIATION_STATUS_COLOR_MAP[participation.deviationStatus] ?? 'info'}
                        icon={<FontAwesomeIcon icon={DEVIATION_STATUS_ICON_MAP[participation.deviationStatus] ?? faFileLines}/>}
                    />
                }
                <div
                    style={{
                        position: "relative",
                        maxWidth: "300px",
                        width: "100%",
                    }}
                    >
                    <QuadralTextField
                        style={{ backgroundColor: "#fff", width: "100%" }}
                        sx={{ marginBottom: 0 }}
                        value={searchValue}
                        onChange={handleSearch}
                        startIcon={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                        placeholder="Rechercher par code contrat"
                        noPadding
                        noMargin
                    />

                    {searchResults.length > 0 && (
                        <div style={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            right: 0,
                            maxHeight: "300px",
                            overflowY: "auto",
                            zIndex: 1000,
                        }}>
                        <QuadralList
                            columns={fastSearchColumns}
                            rows={searchResults.map((result) => ({
                            label: `${result.lastname} ${result.firstname} - ${result.contractCode}`,
                            link: `/enquetes/${result.surveyId}/participations/${result.id}`,
                            }))}
                            headless
                        />
                        </div>
                    )}
                </div>
                { surveyDetails?.endDate &&
                    (() => {
                        const daysRemaining = calculateDaysUntilClosing(surveyDetails.endDate);
                        return daysRemaining !== null ? (
                            <QuadralBadge
                                label={`J-${daysRemaining} avant clôture`}
                                color={getClosingBadgeColor(daysRemaining)}
                                icon={<FontAwesomeIcon icon={faCalendarDays}/>}
                            />
                        ) : null;
                    })()
                }
            </QuadralContainer>
            <Tabs
                value={tabValue}
                onChange={handleTabs}
            >
                <Tab value="1" label="Synthèse" iconPosition="start" icon={<FontAwesomeIcon icon={faChartColumn}/>}/>
                <Tab value="2" label="Personnes" iconPosition="start" icon={<FontAwesomeIcon icon={faUsers}/>}/>
                <Tab value="3" label="Revenus et prestations" iconPosition="start" icon={<FontAwesomeIcon icon={faEuroSign}/>}/>
                <Tab value="4" label="Pièces justificatives" iconPosition="start" icon={<FontAwesomeIcon icon={faFileLines}/>}/>
                <Tab value="5" label="Activités et assistance" iconPosition="start" icon={<FontAwesomeIcon icon={faRotateLeft}/>}/>
            </Tabs>
            <QuadralTabPanel value={tabValue} index={"1"}> 
                <Details
                    showLoader={showLoader}
                    hideLoader={hideLoader}
                    roles={roles}
                    signatoryPerson={signatoryPerson}
                    participation={participation}
                    bailleur={participation?.companyLabel}
                    persons={persons}
                    getDocStatusCount={getDocStatusCount}
                    mapReferences={mapReferences}
                    mapReferenceToOptions={mapReferenceToOptions}
                    setTabValue={setTabValue}
                    refreshPersonsData={refreshPersonsData}
                    quadralToast={quadralToast}
                />
            </QuadralTabPanel>
            <QuadralTabPanel value={tabValue} index={"2"}>
                <PersonList 
                    showLoader={showLoader}
                    hideLoader={hideLoader}
                    participationId={participationId}
                    participation={participation}
                    persons={persons}
                    mapReferenceToOptions={mapReferenceToOptions}
                    refreshPersonsData={refreshPersonsData}
                    quadralToast={quadralToast}
                    docsPerPerson={docsPerPerson}
                /> 
            </QuadralTabPanel>
            <QuadralTabPanel value={tabValue} index={"3"}> 
                <IncomeAndExpenses
                    showLoader={showLoader}
                    hideLoader={hideLoader}
                    participationId={participationId}
                    participation={participation}
                    personIds={personIds}
                    quadralToast={quadralToast}
                />
            </QuadralTabPanel>
            <QuadralTabPanel value={tabValue} index={"4"}>
                <SupportingDocuments 
                    setSupportingDocuments={setSupportingDocuments}
                    participation={participation}
                    persons={persons}
                    personIds={personIds}
                    showLoader={showLoader}
                    hideLoader={hideLoader}
                    id={participationId}
                    updatedData={updatedData}
                    updateData={updateData}
                    getDocStatusCount={getDocStatusCount}
                    canUpdate={canUpdate}
                    references={references}
                    quadralToast={quadralToast}
                    setIsTerminationModalOpen={setIsTerminationModalOpen}
                />
            </QuadralTabPanel>
            <QuadralTabPanel value={tabValue} index={"5"}>  
                <FormControlLabel
                    control={
                        <Switch
                            checked={activitiesOrAssistances}
                            onChange={(event) =>
                                setActivitiesOrAssistances(event.target.checked)
                            }
                        />
                    }
                    label={activitiesOrAssistances ? "Activités" : "Assistances"}
                />
                {activitiesOrAssistances ? (
                    <Activities
                        setActivityOrder={setActivityOrder} 
                        setAssistanceType={setAssistanceType}
                        assistanceType={assistanceType} 
                        activityRecords={activityRecords} 
                        formatDate={formatDate}
                    />
                ) : (
                    <Assistance
                        participationId={participationId}
                        quadralToast={quadralToast}
                        deviationId={deviationId}
                        display={roles}
                        formatDate={formatDate}
                        showLoader={showLoader}
                        hideLoader={hideLoader}
                        updateRecord={updateRecord}
                        assistanceRecords={assistanceRecords}
                    />
                )}
            </QuadralTabPanel>
        </div>
    );
};

export default SurveyParticipation;